import { useMemo } from 'react';

import { useGetRealTimeList } from '~hooks/query/home/useRealTimeList';

export interface RealTimeData {
  id: number;
  CMPN_NM: string;
  PK_NM_HASH: string;
}

export function useGetSlicedList() {
  const { data, status, refetch } = useGetRealTimeList();
  const slicedList = useMemo<RealTimeData[]>(() => {
    if (status !== 'success') {
      return [];
    }

    return data.realTime.slice(0, 4);
  }, [data, status]);

  return { slicedList, status, refetch };
}
